import { IMapGeoObject } from '@cian/frontend-newbuilding-map-component';

import {
  INSIDE_INFRASTRUCTURE_TYPE_TO_PROPERTY_MAP,
  OUTSIDE_INFRASTRUCTURE_TYPE_TO_PROPERTY_MAP,
} from 'shared/constants/transportAccessibilityInfrastructure';
import {
  ITAInfrastructure,
  ITAInfrastructureData,
  ITAInfrastructureItem,
  TTAInfrastructureType,
} from 'shared/types/map';
import { getGeoObject } from 'shared/utils/map';

import { getAvailableInsideInfrastructureTypes } from './getAvailableInsideInfrastructureTypes';
import { getAvailableOutsideInfrastructureTypes } from './getAvailableOutsideInfrastructureTypes';

export function getTransportAccessibilityInfrastructureMapByType(
  main: IMapGeoObject,
  mainPolygon: IMapGeoObject | null,
  transportAccessibilityInfrastructure: ITAInfrastructure | undefined,
) {
  const map = new Map<TTAInfrastructureType, ITAInfrastructureData>();

  if (!transportAccessibilityInfrastructure) {
    return map;
  }

  const availableOutsideInfrastructure = getAvailableOutsideInfrastructureTypes(transportAccessibilityInfrastructure);

  availableOutsideInfrastructure.forEach(infrastructureType => {
    const infrastructureItems =
      transportAccessibilityInfrastructure.outside[OUTSIDE_INFRASTRUCTURE_TYPE_TO_PROPERTY_MAP[infrastructureType]] ||
      [];

    infrastructureItems.forEach(item => addItemToMap(item, infrastructureType, map));

    addMainItems(main, mainPolygon, infrastructureType, map);
  });

  const { existingInfrastructureTypes } = getAvailableInsideInfrastructureTypes(transportAccessibilityInfrastructure);

  existingInfrastructureTypes.forEach(infrastructureType => {
    const infrastructureItems =
      transportAccessibilityInfrastructure.inside[INSIDE_INFRASTRUCTURE_TYPE_TO_PROPERTY_MAP[infrastructureType]] || [];

    infrastructureItems.forEach(item => addItemToMap(item, infrastructureType, map));

    addMainItems(main, mainPolygon, infrastructureType, map);
  });

  return map;
}

function addItemToMap(
  item: ITAInfrastructureItem,
  type: TTAInfrastructureType,
  map: Map<TTAInfrastructureType, ITAInfrastructureData>,
) {
  const { coordinates, id } = item;

  const geoObjectsData = map.get(type)?.geoObjectsData || [];

  const geoObject = getGeoObject({ name: type, coordinates, id });

  geoObjectsData.push({
    geoObject,
    infrastructureItem: item,
  });

  map.set(type, { geoObjectsData });

  return map;
}

function addMainItems(
  main: IMapGeoObject,
  mainPolygon: IMapGeoObject | null,
  infrastructureType: TTAInfrastructureType,
  map: Map<TTAInfrastructureType, ITAInfrastructureData>,
) {
  const geoObjectsData = map.get(infrastructureType)?.geoObjectsData || [];
  geoObjectsData.push({ geoObject: main, infrastructureItem: null });

  if (mainPolygon) {
    geoObjectsData.push({ geoObject: mainPolygon, infrastructureItem: null });
  }

  map.set(infrastructureType, { geoObjectsData });
}
